<template>
  <div class="animated fadeIn">
    <!-- 시스템 설정임 -->
    <b-card no-body border-variant="warning">
      <b-tabs v-model="index" content-class="mt-3" fill justified>
        <b-tab :title="model.license.code.toUpperCase()" active v-if="model.license.code">
          <b-row>
            <b-col md="6" class="text-center">
              F1-UWSS License, Expire :
              <b-badge variant="success">{{model.license.data.summary.expire | datetime}}</b-badge>
              <br>
              If you will change setting, Applies at least 30 minutes later.
            </b-col>
            <b-col md="2"> OnPremise </b-col>
            <b-col md="3">
              <c-switch :disabled="true" v-if="model.license.data.summary" color="info" label v-model="model.license.data.summary.onPremise" />
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6" class="text-center">
            </b-col>
            <b-col md="6">
              <small>
                * If it's OnPremise, you can't issue an invoice or pay for credit automatically.
              </small>
            </b-col>
          </b-row>
          <hr>
          <b-row v-if="model.license.data.summary.Group">
            <b-col md="2"> Group <small>(Max)</small> </b-col>
              <b-col md="1">
                <c-switch :disabled="true" v-if="model.license.data.summary.Group" color="info" label v-model="model.license.data.summary.Group.use" />
              </b-col>
              <b-col md="3"><b-input :disabled="true" v-if="model.license.data.summary.Group" v-model="model.license.data.summary.Group.qty" placeholder="Service count" ></b-input></b-col>
              <b-col md="2"> User <small>(Max)</small> </b-col>
              <b-col md="1">
                <c-switch :disabled="true" v-if="model.license.data.summary.User" color="info" label v-model="model.license.data.summary.User.use" />
              </b-col>
              <b-col md="3"><b-input :disabled="true" v-if="model.license.data.summary.User" v-model="model.license.data.summary.User.qty" placeholder="Service count" ></b-input></b-col>
          </b-row>
          <hr>
          <b-row v-if="model.license">
            <b-col md="2"> WSFinder <small>(Max)</small> </b-col>
            <b-col md="1">
              <c-switch :disabled="true" v-if="model.license.data.summary.WSFinder" color="info" label v-model="model.license.data.summary.WSFinder.use" />
            </b-col>
            <b-col md="3"><b-input :disabled="true" v-if="model.license.data.summary.WSFinder" v-model="model.license.data.summary.WSFinder.qty" placeholder="Service count" ></b-input></b-col>
            <b-col md="2"> WEBCastle <small>(Max)</small> </b-col>
            <b-col md="1">
              <c-switch :disabled="true" v-if="model.license.data.summary.WEBCastle" color="info" label v-model="model.license.data.summary.WEBCastle.use" />
            </b-col>
            <b-col md="3"><b-input :disabled="true" v-if="model.license.data.summary.WEBCastle" v-model="model.license.data.summary.WEBCastle.qty" placeholder="Service count" ></b-input></b-col>
          </b-row>
          <hr>
          <b-row v-if="model.license">
            <b-col md="2"> WMDS <small>(Max)</small> </b-col>
            <b-col md="1">
              <c-switch :disabled="true" v-if="model.license.data.summary.WMDS" color="info" label v-model="model.license.data.summary.WMDS.use" />
            </b-col>
            <b-col md="3"><b-input :disabled="true" v-if="model.license.data.summary.WMDS" v-model="model.license.data.summary.WMDS.qty" placeholder="Service count" ></b-input></b-col>
            <b-col md="2"> WFDetector <small>(Max)</small> </b-col>
            <b-col md="1">
              <c-switch :disabled="true" v-if="model.license.data.summary.WFDetect" color="info" label v-model="model.license.data.summary.WFDetect.use" />
            </b-col>
            <b-col md="3"><b-input :disabled="true" v-if="model.license.data.summary.WEBCastle" v-model="model.license.data.summary.WEBCastle.qty" placeholder="Service count" ></b-input></b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="2"><span>Site License</span></b-col>
            <b-col md="8"><b-input :type="toggle" v-model="model.license.data.info.key" placeholder="ex) Please enter the license key for the UWSS platform." ></b-input></b-col>
            <b-col md="2">
              <b-button variant="danger" type="button" @click="confirm_save = true; type = 'license'">Apply</b-button>
              <b-button variant="primary" type="button" @click="toggle = toggle == 'password' ? 'text' : 'password'; type = 'license'">
                {{toggle == 'password' ? 'Show' : 'Hide'}}
              </b-button>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            {{model.data}}
            <b-col md="2"><span>License Auth URL</span></b-col>
            <b-col md="8"><b-input type="text" v-model="model.license.data.info.url" placeholder="ex) Please enter the URL of the server to be authenticated." ></b-input></b-col>
            <b-col md="2">
              <b-button block variant="danger" type="button" @click="confirm_save = true; type = 'license'">Apply</b-button>
            </b-col>
          </b-row>
        </b-tab>
        <!-- 메일설정 -->
        <b-tab :title="model.mail.code.toUpperCase()" v-if="model.mail.code">
          <b-row>
            <b-col md="3"><span>From</span></b-col>
            <b-col md="9"><b-input v-model="model.mail.data.from" placeholder="ex) f1uwss@f1security.co.kr" ></b-input></b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="3"><span>Username</span></b-col>
            <b-col md="9"><b-input v-model="model.mail.data.username" placeholder="ex) user username for SMTP" ></b-input></b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="3"><span>Password</span></b-col>
            <b-col md="9"><b-input type="password" v-model="model.mail.data.password" placeholder="ex) your secret password for SMTP" ></b-input></b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="3"><span>PORT</span></b-col>
            <b-col md="9"><b-input v-model="model.mail.data.port" placeholder="ex) 587" ></b-input></b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="3"><span>SMTP Server</span></b-col>
            <b-col md="9"><b-input v-model="model.mail.data.server" placeholder="ex) smtp.main.org" ></b-input></b-col>
          </b-row>
          <hr>
          <b-button variant="danger" type="button" block @click="confirm_save = true; type = 'mail'">Save</b-button>
        </b-tab>
        <b-tab no-body :title="model.rule.code.toUpperCase()" v-if="model.rule.code">
          <b-button variant="info" type="button" block>WMDS</b-button>
          <hr>
          <!-- WMDS -->
          <b-row>
            <b-col md="3"><span>Init</span></b-col>
            <b-col md="9">
              <c-switch color="info" label v-model="model.rule.data.wmds.init" />
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="3"><span>Status</span></b-col>
            <b-col md="9">
              <c-switch color="info" label v-model="model.rule.data.wmds.is_run" />
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="3"><span>Point : cp</span></b-col>
            <b-col md="9"><b-input v-model="model.rule.data.wmds.cp" placeholder="ex) pattern update check point" ></b-input></b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="3"><span>Rule Server</span></b-col>
            <b-col md="9"><b-input v-model="model.rule.data.wmds.url" placeholder="ex) Rule update remote server" ></b-input></b-col>
          </b-row>
          <hr>
          <b-button variant="info" type="button" block>WSFinder</b-button>
          <!-- WSFinder -->
          <hr>
          <b-row>
            <b-col md="3"><span>Init</span></b-col>
            <b-col md="9">
              <c-switch color="info" label v-model="model.rule.data.wsfinder.init" />
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="3"><span>Status</span></b-col>
            <b-col md="9">
              <c-switch color="info" label v-model="model.rule.data.wsfinder.is_run" />
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="3"><span>Point : cp</span></b-col>
            <b-col md="9"><b-input v-model="model.rule.data.wsfinder.cp" placeholder="ex) pattern update check point" ></b-input></b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="3"><span>Rule Server</span></b-col>
            <b-col md="9"><b-input v-model="model.rule.data.wsfinder.url" placeholder="ex) Rule update remote server" ></b-input></b-col>
          </b-row>
          <hr>
          <b-button variant="danger" type="button" block @click="confirm_save = true; type = 'rule'">Save</b-button>
        </b-tab>
        <!-- 로고 -->
        <!-- <b-tab :title="model.logo.code.toUpperCase()" active v-if="model.logo && model.logo.code"> -->
        <b-tab :title="'CUSTOM'" active v-if="model.logo && model.logo.code">
          <b-row>
            <b-col md="2">
              Slogan
            </b-col>
            <b-col md="10">
              <b-input v-model="model.logo.data.slogan" placeholder="ex) F1-UWSS" ></b-input>
              <br>
              <small>* You can set the logo displayed on the screen where the user login.</small>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="2">
              Logo
            </b-col>
            <b-col md="10">
              <picture-input
                :z-index="2"
                radius="3"
                :prefill="model.logo.data.image"
                v-show="!confirm_save && !confirm_refresh"
                ref="pictureInput"
                height="150" min-height="150" width="800" max-width="800" max-height="800"
                accept="image/*" size="2" button-class="btn btn-dark"
                :custom-strings="{
                  upload: '<h1>test!</h1>',
                  drag: '<small>Drag & Drop<small>',
                }"
                @change="logo_change">
              </picture-input>
              <br>
              <small>* You can set the login slogan that is displayed on the screen where the user login.  <span class='text-danger'>(Minimum Recommended Size : 800px X 200px)</span> </small>
              <b-button size="sm" class="m-1 float-right" variant="warning" @click="model.logo.data.image = ''">Clear</b-button>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="2">
              Logo favicon.ico
              <b-badge variant="danger" v-if="favicon">Using</b-badge>
            </b-col>
            <b-col md="10" class="text-center">
              <p v-if="!favicon">
                <b-form-file
                placeholder="Choose a file or drop it here..."
                @input="input_favicon"
                ></b-form-file>
              </p>
              <b-img v-else :src="favicon"></b-img>
              <hr>
              <small>* favicon is  shortcut icon, website icon, tab icon, URL icon, or bookmark icon  <span class='text-danger'>(Minimum Recommended Size : 800px X 200px)</span> </small>
              <b-button size="sm" class="m-1 float-right" variant="warning" @click="favicon = ''">Clear</b-button>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="2">
              Support Email
              <br>
              <small>(CC reference all)</small>
            </b-col>
            <b-col md="10">
              <b-input v-model="model.logo.data.support" placeholder="ex) support@f1security.co.kr,uwss@f1security.co.kr" ></b-input>
              <br>
              <small>* Authentication-related mail, such as finding passwords, is referenced to all mail guides for technical support</small>
              <br>
              <small>[ex) admin@f1security.co.kr,support@f1secuirty.co.kr...]</small>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="2">
              Manual URL
            </b-col>
            <b-col md="10">
              <b-input v-model="model.logo.data.manual" placeholder="ex) https://f1security.co.kr/manual.pdf" ></b-input>
              <br>
              <small>* Default is F1-UWSS Manual URL (<b-button variant="link" @click="redirect_manual()">{{config.manual}}</b-button>)</small>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="2">
              Help Email
            </b-col>
            <b-col md="10">
              <b-input v-model="model.logo.data.help" placeholder="ex) help@uwss.kr" ></b-input>
              <br>
              <small>Mail address that notifies end customers, partners of a public reply.  You will receive inquiries from the users via the mail you set up</small>
            </b-col>
          </b-row>
          <!-- <hr> -->
          <!-- <b-row>
            <b-col md="2">
              Address
            </b-col>
            <b-col md="10">
              <b-input v-model="model.logo.data.address" placeholder="ex) #1402, 234, Beotkkot-ro, Geumcheon-gu, Seoul, Republic of Korea." ></b-input>
              <br>
              <small>This address will be shown in the mail</small>
            </b-col>
          </b-row> -->
          <hr>
          <b-button v-if="model.invoice.data && model.invoice.data.image" block variant="primary" type="button" @click="clear_logo">Clear</b-button>
          <b-button block variant="danger" type="button" @click="confirm_save = true; type = 'logo'">Apply</b-button>
        </b-tab>
        <!-- 인보이스 -->
        <b-tab :title="'Invoice'" active v-if="model.invoice && model.invoice.code">
          <b-row>
            <b-col md="2">
              Company
            </b-col>
            <b-col md="4">
              <b-input v-model="model.invoice.data.company" placeholder="ex) F1 Security Inc" ></b-input>
            </b-col>
            <b-col md="2">
              Contact
            </b-col>
            <b-col md="4">
              <b-input v-model="model.invoice.data.contact" placeholder="ex) +82 070-4640-3030" ></b-input>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="2">
              Business Number
            </b-col>
            <b-col md="10">
              <b-input v-model="model.invoice.data.business_number" placeholder="ex) F1 Security Inc" ></b-input>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="2">
              Address
            </b-col>
            <b-col md="10">
              <b-input v-model="model.invoice.data.company_address" placeholder="ex) F1 Security office location" ></b-input>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="2">
              Issuer
            </b-col>
            <b-col md="4">
              <b-input v-model="model.invoice.data.issuer" placeholder="ex) F1 Security Inc" ></b-input>
            </b-col>
            <b-col md="2">
              Issuer Email
            </b-col>
            <b-col md="4">
              <b-input v-model="model.invoice.data.issuer_email" placeholder="ex) F1 Security Inc" ></b-input>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="2">
              Bank Name
            </b-col>
            <b-col md="4">
              <b-input v-model="model.invoice.data.bank_name" placeholder="ex) F1security Bank" ></b-input>
            </b-col>
            <b-col md="2">
              Bank Number
            </b-col>
            <b-col md="4">
              <b-input v-model="model.invoice.data.bank_number" placeholder="ex) -" ></b-input>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="2">
              Bank Swift Code
            </b-col>
            <b-col md="4">
              <b-input v-model="model.invoice.data.swift_code" placeholder="Optional" ></b-input>
            </b-col>
            <b-col md="2">
              Account Holder
            </b-col>
            <b-col md="4">
              <b-input v-model="model.invoice.data.account_holder" placeholder="ex) F1 Security Inc" ></b-input>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="2">
              Bank branch
            </b-col>
            <b-col md="10">
              <b-input v-model="model.invoice.data.bank_branch" placeholder="Optional" ></b-input>
            </b-col>
          </b-row>
          <hr>
          <small>* This information is shown when an invoice is issued on the platform.</small>
          <hr>
          <b-row>
            <b-col md="2">
              Issue Day
            </b-col>
            <b-col md="4">
              <b-input type="number" v-model="model.invoice.data.issue_day" placeholder="default day is 1" ></b-input>
              <small>choice invoice issue day of the month</small>
            </b-col>
            <b-col md="1">
              Pay Day
            </b-col>
            <b-col md="5">
              <b-input type="number" v-model="model.invoice.data.pay_day" placeholder="default day is 5" ></b-input>
              <small>Specifies the date of automatic payment of invoices issued as deposits</small>
            </b-col>
          </b-row>

          <hr>
          <b-button v-if="model.invoice.data && model.invoice.data.image" block variant="primary" type="button" @click="clear_logo">Clear</b-button>
          <b-button block variant="danger" type="button" @click="confirm_save = true; type = 'invoice'">Apply</b-button>
        </b-tab>
      </b-tabs>
    </b-card>

    <!-- 시스템의 기본 서비스 관리 추가 -->
    <ServiceList />
    <!-- <b-card border-variant="primary" id="list">
      <template slot="header">
        <i class='fa fa-align-justify'></i> UWSS Base Service
      </template>
      <b-row>
        <b-col md="9">
          <h4>
            <b-badge variant="danger">* Notice</b-badge>
          </h4>
          - Newly created services are available to partners after the system is created.
        </b-col>
        <b-col md="3">
          <b-button size="sm" variant="success" class="pull-right mx-1" @click="service_new = true; confirm_info = true; service = {}"> New Registration </b-button>
          <b-button size="sm" variant="info" class="pull-right mx-1" @click="$refs._list.refresh()"> Refresh </b-button>
        </b-col>
      </b-row>
      <hr> -->



      <!-- <b-table hover striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="not found"
        :items="load_service" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk">
        <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
        <template slot="is_alive" slot-scope="row">
          <c-switch @change="status_change($event, row.item, 'is_alive')" color="warning" label v-model="row.item.status" />
        </template>
        <template slot="name" slot-scope="row">
          <b-btn @click="status_change(row.item, row.item, 'is_del')" variant="outline-danger" size="sm">Delete</b-btn>
          {{row.item.name}}
        </template>
        <template slot="list_price" slot-scope="row">{{row.item.list_price | dollar}}</template>
        <template slot="min_price" slot-scope="row">{{row.item.min_price | dollar}}</template>
        <template slot="func" slot-scope="row">
          <b-btn @click="detail(row.item)" size="sm" variant="outline-primary">Select</b-btn>
        </template>
      </b-table> -->
    <!-- </b-card> -->

    <!-- 기존 파트너의 가격 수정 여부 확인 모달 -->
    <b-modal hide-footer title="System service price was changed"  class="modal-warning" v-model="confirm_all">
      you want to apply a new price to my existing partner?
      if press "only update the price.", Accounts created after application will be affected by the price updated
      <b-button class="mt-3" variant="outline-warning" block @click="confirm_all = false; upsert_service()">only update the price.</b-button>
      <b-button class="mt-3" variant="outline-danger" block @click="service.apply_all = true; upsert_service()">Apply the price</b-button>
    </b-modal>
    <!-- 미사용 확인 모달 -->
    <b-modal title="System update info"  class="modal-danger" v-model="confirm_save" @ok="confirm_refresh = true" ok-variant="danger">
      Are you sure you want to update this info?
    </b-modal>
    <!-- 적용을 위한 페이지 새로고침 안내 -->
    <b-modal title="System refresh notice"  header-bg-variant="info" ok-only v-model="confirm_refresh" @ok="save" ok-variant="info">
      A page refresh is required to apply the changed settings,
      <br>
      which will be automatically refreshed 3 seconds after applying the settings.
      <br>
      Don't be surprised.😉
    </b-modal>
  </div>
</template>

<script>
import { Api } from '@/service';
import DatePicker from 'vue2-datepicker'
import custom from '@/custom';
import config from '@/config';
import codes from '@/codes';
import { Switch as cSwitch } from '@coreui/vue';
import vSelect from 'vue-select';
import PictureInput from 'vue-picture-input' // https://github.com/alessiomaffeis/vue-picture-input good boy
import ServiceList from './Setting.Service'

let default_opt = function() {
  return {
    perPage: 15,
    currentPage: 1, totalRows: 0,
    sk: '', sv: '', skt: '', opt : {}, adv : false
  }
}

export default {
  components: { DatePicker, cSwitch, vSelect, PictureInput, ServiceList },
  name : "SettingList",
  props : ["auto_refresh", "enable_new", "view_detail"],
  data: () => ({
    index : 0,
    favicon : '',
    file : {},
    config,
    loading : false,
    lock : true,
    confirm_refresh : false,
    confirm_all : false,
    confirm_info: false,
    confirm_toggle : false,
    confirm_delete : false,
    confirm_save : false,
    type : '',
    toggle : 'password',
    custom,
    codes,
    service_new : false,
    service : {},
    so : default_opt(),
    model : { total : 0, enable : 0, disable : 0,
      license : { data : {}, data_json : { key : {}, info : {} }, list : [] },
      logo : { data : { slogan : '', image : ''} },
      mail : { data : {} },
      rule : { data : { wsfinder : { init : false, is_run : false, cp : 0, url : ''  }, wmds : { init : false, is_run : false, cp : 0, url : '' } } },
      invoice : { data : { issue_day : 1, pay_day : 5 } }
    },
    sync : { interval : 15, stop : false, th : undefined },
  }),
  computed: {
    url() { return `https://${location.host.replace(/^[^\\.]*\./, 'api.')}/downloads/manual/${config.manual}` },
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      let f = []
      f.push({ key: 'id', thStyle: 'width: 10%', label: 'No.' })
      f.push({ key: 'is_alive', sortable: true, label: 'Status'});
      f.push({ key: 'name', sortable: true, label: 'Name'});
      f.push({ key: 'list_price', sortable: true, label: 'Public price' });
      f.push({ key: 'min_price', label: 'Cost price', sortable: true });
      f.push({ key: 'func', label: 'Action', sortable: false, thStyle: 'width: 10%'  });
      return f;
    },
  },
  methods: {
    async input_favicon(x) {
      let getBase64 = (file) => {
        return new Promise((resolve, reject) => {
          var reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = function () {
            resolve(reader.result)
          };
          reader.onerror = function (error) { console.log('Error: ', error); };
        })

      }
      this.file = x
      this.file = Object.assign({}, this.file, { base64 : await getBase64(x) })
      this.favicon = this.file.base64
      // console.log('input_favicon', x, rs)
    },
    redirect_manual() {
      window.open(`https://${location.hostname == 'localhost' ? 'api.f1secaas.net' : location.host.replace(/^[^\\.]*\./, 'api.')}/downloads/manual/${config.manual}`)
    },
    cancel() {
      if(this.$refs._list) { this.$refs._list.refresh() }
      this.confirm_toggle = false
    },
    clear_logo() {
      this.model.logo.data = { image : '', slogan : '', support : ''}
      this.image = ''
    },
    logo_change (image) {
      console.log('New picture selected!')
      if (image) {
        console.log('Picture loaded.', image)
        this.image = image
      } else {
        console.log('FileReader API not supported: use the <form>, Luke!')
      }
    },
    async load() {
      try {
        let so = { target : 'settings', cmd : 'list', body : { ts : new Date().getTime() } }

        // let so = { target : 'settings', cmd : 'list', body : { sort : [{ name : 'id', op : 'desc'}], or : [], and : []  } }

        let rs = await Api.Manager(so);
        if(rs.error) {
          return this.$toastr.e("load failed", this.$route.name)
        }

        rs.body.forEach(r => {
          let row = {}

          if(r.code == 'license')
          {
            try { r.data.info = JSON.parse(r.data.info) }
            catch (e) { console.error(e) }
            // console.log(r.data.info, 'WTF')
            if(!r.data.info.key) {
              // 하위 호환
              r.data = { info : { key : r.data.info, url : '' }, summary : r.data.summary }
              // console.log('하위 호환', r.data, r.code)
            }
          }

          if(r.code == 'logo') {
            this.image = r.data && r.data.images ? r.data.images : '';
            this.favicon = r.data && r.data.favicon ? r.data.favicon : '';
          }

          if(r.code == 'rule') {
            if(!r.data.wmds) {
              let data = r.data
              delete data.wmds
              delete data.wsfinder
              r.data = Object.assign({}, r.data, { wmds : data })
            }

            if(!r.data.wsfinder) {
              r.data = Object.assign({}, r.data, { wsfinder : this.model.rule.data.wsfinder })
            }
          }

          row[r.code] = r;
          // console.log('row', row, r)
          this.model = Object.assign({}, this.model, row);
        });
      } catch (e) { console.log(e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText) }
    },
    save: async function() {
      try {
        let model = {}
        switch (this.type) {
          case 'license':
            model = Object.assign({}, model, { id : this.model.license.id, data : { key : this.model.license.data.info.key, url : this.model.license.data.info.url} })
            break;
          case 'mail':
            model = Object.assign({}, model, { id : this.model.mail.id, data : this.model.mail.data })
            break;
          case 'rule':
            model = Object.assign({}, model, { id : this.model.rule.id, data : this.model.rule.data })
            // if(!model.rule.data.wmds) {
            //   let data = model.rule.data
            //   delete data.wsfinder
            //   delete data.wmds
            //   model.rule.data.wmds = data

            // }
            break;
          case 'logo':
            model = Object.assign({}, model, { id : this.model.logo.id, data :
              {
                image : this.image ? this.image : this.model.logo.data.image,
                slogan : this.model.logo.data.slogan,
                support : this.model.logo.data.support,
                manual : this.model.logo.data.manual,
                favicon : this.favicon ? this.favicon : '',
                help : this.model.logo.data.help ? this.model.logo.data.help : ''
              }
            })
            break;
          case 'invoice':
            model = Object.assign({}, model, { id : this.model.invoice.id, data :
              {
                business_number : this.model.invoice.data.business_number,
                company : this.model.invoice.data.company,
                contact : this.model.invoice.data.contact,
                issuer : this.model.invoice.data.issuer,
                issuer_email : this.model.invoice.data.issuer_email,
                bank_name : this.model.invoice.data.bank_name,
                bank_number : this.model.invoice.data.bank_number,
                swift_code : this.model.invoice.data.swift_code,
                account_holder : this.model.invoice.data.account_holder,
                bank_branch : this.model.invoice.data.bank_branch,
                company_address : this.model.invoice.data.company_address,
                pay_day : this.model.invoice.data.pay_day,
                issue_day : this.model.invoice.data.issue_day,

              }
            })
            // console.log(model)
            break;
          default:
            break;
        }
        if(model == {}) { return this.$toastr.w("reuire", "update type") }

        let rs = await Api.Manager_Call('settings', model.id ? 'update' : 'insert', model);
        if(!rs.error) {
          this.$toastr.s('Saved', "soon refresh 3 sec later"); this.list();
          setTimeout(() => location.reload(), 3000)
        } else {
          this.$toastr.e('Save', "failed"); this.list();
        }
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); this.list()}
    },
    list() { this.$emit('refresh'); },
  },
  created() { console.log('group.list.vue', 'created'); },
  destroyed() { console.log('group.list.vue', 'destroyed'); },
  mounted() {
    console.log('group.list.vue', 'mounted');
    this.load();
    // if(location.hostname == 'localhost') { setTimeout(() => this.index = 0, 1000) }

  },
}
</script>
